define('Components/LandingWidget/js/views/LandingWidgetInstanceView',['jquery', 'underscore', 'app', 'WidgetInstanceView',
    'template!Components/LandingWidget/templates/summer-box',
    'template!Components/LandingWidget/templates/summer-creations',
    'template!Components/LandingWidget/templates/fidelity',
    'template!Components/LandingWidget/templates/corners'
],
    function ($, app, _, WidgetInstanceView,
        summerBoxTemplate,
        summerCreationsTemplate,
        fidelityTemplate,
        wuakiTemplate,
        cornersTemplate
    ) {
        return WidgetInstanceView.extend({
            name: 'LandingWidgetInstanceView',
            getTemplate: function () {
                var templateName = this.model.getTemplate();
                switch (templateName) {
                    case 'corners':
                        return cornersTemplate;
                        break;
                    case 'fidelity':
                        return fidelityTemplate;
                        break;
                    case 'summer-box':
                        return summerBoxTemplate;
                        break;
                    case 'summer-creations':
                        return summerCreationsTemplate;
                        break;
                    default:
                        return _('<div class="alert alert-danger">'+templateName+' : non disponible au templating JS</div>');
                }
            }
        })
});
